var _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreditNoteWithDatecomponent = function SvgCreditNoteWithDatecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#CreditNoteWithDate_component_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 16h2V4H9v2h8v10Zm0 2v3c0 .552-.45 1-1.007 1H4.007A1 1 0 0 1 3 21l.003-14c0-.552.45-1 1.007-1H7V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3ZM7 16v2h2v1h2v-1h.5a2.5 2.5 0 0 0 0-5h-3a.5.5 0 0 1 0-1H13v-2h-2V9H9v1h-.5a2.5 2.5 0 0 0 0 5h3a.5.5 0 0 1 0 1H7Z",
    fill: "current"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 22,
    r: 8,
    fill: "#FBFBFA",
    stroke: "#FBFBFA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.993 15A6.997 6.997 0 0 0 10 22c0 3.864 3.129 7 6.993 7A7.004 7.004 0 0 0 24 22c0-3.864-3.136-7-7.007-7ZM17 27.6a5.598 5.598 0 0 1-5.6-5.6c0-3.094 2.506-5.6 5.6-5.6s5.6 2.506 5.6 5.6-2.506 5.6-5.6 5.6Zm-.7-9.1h1.05v3.675l3.15 1.869-.525.861L16.3 22.7v-4.2Z",
    fill: "current"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "CreditNoteWithDate_component_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCreditNoteWithDatecomponent;